import { CallbackObject } from 'api/core/get-page-function';
import { GetStoredItemsVm } from './get-stored-items.vm';
import { plainToClass } from 'class-transformer';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';


export const getStoredItems = async (
    warehouseId: string,
    productId: string | null,
    locationId: string | null,
    offset: string | null,
    callback: CallbackObject<GetStoredItemsVm>
) => {
    const config: Record<string, any> = {
        headers: {
            "Content-Type": "application/json",
        },
        params: {
            limit: 50,
            offset: offset,
            warehouseId: warehouseId
        },
    };

    if (productId) {
        config.params.productId = productId
    }

    if (locationId && locationId.length) {
        config.params.locationId = locationId
        config.params.locationIdStrict = false
    }

    try {
        const res: AxiosResponse = await instance.get(`/picking/items`, config);
        callback.success(plainToClass(GetStoredItemsVm, res.data));
    } catch (err) {
        if (callback.error) callback.error(err);
    }
}